import { Observable, Subject } from "rxjs";
import { ConditionListsAgreementModel } from "../../models/components/condition-lists-agreement.model";

export abstract class ProductPopUpBaseService<TPopUpModel> {
    private visiblePopUp = new Subject<TPopUpModel>();
    private hiddenPopUp = new Subject<ConditionListsAgreementModel>();

    public get showPopUpObservable(): Observable<TPopUpModel> {
        return this.visiblePopUp.pipe();
    }

    public get hidePopUpObservable(): Observable<ConditionListsAgreementModel> {
        return this.hiddenPopUp.pipe();
    }

    public showPopUp(model: TPopUpModel): void {
        console.log("IN pop-up-service SHOW POP UP");
        this.visiblePopUp.next(model);
    }

    public hidePopup(): void {
        this.hiddenPopUp.next(null);
    }
}
